<template>
<div class="page-linker">
	<div class="mask" v-if="!inner"></div>
	<div :class="{'dig': !inner}">
		<div class="dig_title clearFix" v-if="!inner">
			<div class="fl"><b class="mark_choose"></b>设置链接</div>
			<i class="fr ivu-icon ivu-icon-close-round" @click.native="popupClose"></i>
		</div>
		<div class="box-main" :style="{margin: inner?'0':'30px 0'}">
			<RadioGroup size="large" @on-change="etabSwitch" v-model="lnkobj.type" style="margin-bottom:10px">
				<Radio label="page">页面</Radio>
				<Radio label="func">功能</Radio>
				<Radio label="none">无</Radio>
			</RadioGroup>
			<div class="box-form" v-if="lnkobj.type=='page'">
				<inline-linker size="large" :data="pages" v-model="lnkobj.param.value" :placement="placement" placeholder="连接至..." filterable></inline-linker>
			</div>
			<template v-if="lnkobj.type=='func'">
			<div class="box-form">
				<Select size="large" :placement="placement" v-model="lnkobj.param.type" placeholder="调用功能...">
					<Option value="callto">拨打电话</Option>
					<Option value="product_list">产品列表</Option>
					<Option value="product_detail">产品详情</Option>
				</Select>
			</div>
			<div class="box-form sub-box-form" v-if="lnkobj.param.type=='callto'">
				<Input size="large" v-model="lnkobj.param.value" placeholder="请输入电话号码..."></Input>
			</div></template>
		</div>
		<div class="dig-footer clearfix" v-if="!inner">
			<Button type="text" @click.native="popupClose">取 消</Button>
			<Button type="primary" @click.native="linkerSet">确 定</Button>
		</div>
	</div>
</div>
</template>

<script>
import jGlobal from '@/global';
import EventBus from '@/common/events';

let lnkobj_default = {type: 'none',param: {type: '',value: '',pagevalue: '',idsvalue: '',title: ''}};
export default
{
	data (){
		return {
			pages: [],
			lnkobj: {},
			placement: 'top'
		}
	},
	created (){
		let curpage = jGlobal.getCurPage();
		this.pages = curpage.pages;
		if (! $.isPlainObject(this.attrs || {})
		  || $.isEmptyObject(this.attrs || {})) return false;
		
		this.$watch('attrs.id', () => {
			this.lnkobj = $.extend(true, {}, lnkobj_default, this.value || {});
			this._data.placement = (this._props.attrs.type == 'buttons')?'bottom':'top'
		}, {deep: true,immediate: true});
		
		this.$watch('lnkobj', res => this.$emit("input", res), {deep: true})
	},
	mounted (){
		!this.inner && $(this.$el).appendTo('body')
	},
	methods: {
		etabSwitch (etype){
			this.lnkobj.type = etype;
			let tmpobj = $.extend(true, {}, lnkobj_default);
			this.lnkobj.param = tmpobj.param
		},
		linkerSet (){
			EventBus.$emit("set_linker", this.lnkobj);
			this.popupClose()
		},
		popupClose (){
			EventBus.$off("set_linker");
			EventBus.$emit("pagelinker_close")
		}
	},
	props: ['value', 'inner', 'attrs']
}
</script>

<style scoped>
.fl {float: left;}
.fr {float: right;}
.mask {background-color: rgba(0, 0, 0, 0.5);position: fixed;height: 100%;width: 100%;left: 0;top: 0;z-index: 10002;}
.dig {background-color: #fff;position: fixed;left: 50%;top: 50%;width: 380px;-webkit-transform: translate3d(-50%, -50%, 0);transform: translate3d(-50%, -50%, 0);z-index: 10003;}
.dig_title {border-bottom: 1px solid #dddee1;border-top: 4px solid #2d8cf0;background-color: #fafafa;font-size: 14px;color: #2d8cf0;width: 100%;height: 64px;line-height: 60px;padding: 0 15px;}
.dig_title .fr {padding: 5px;margin-top: 17px;color: #bfbfbf;cursor: pointer;}
.mark_choose {display: inline-block;width: 5px;height: 14px;background-color: #2d8cf0;border-radius: 5px;vertical-align: middle;margin-right: 10px;}
.dig-footer {text-align: right;margin-bottom: 30px;margin-right: 25px;}
.box-main {padding-left: 70px;padding-right: 25px;}
.box-main .box-form {padding: 15px;background-color: #fafafa;border-radius: 4px;border: 1px solid #dddee1;}
.box-main .box-form.sub-box-form {margin-top: 10px;}
</style>


// WEBPACK FOOTER //
// pagelinker.vue?5a3a205a